import { render } from "./feedinfo.vue?vue&type=template&id=5dcbe301&scoped=true"
import script from "./feedinfo.vue?vue&type=script&lang=js"
export * from "./feedinfo.vue?vue&type=script&lang=js"

import "./feedinfo.vue?vue&type=style&index=0&id=5dcbe301&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcbe301"]])

export default __exports__